(() => {
  if (customElements.get('pr-pack-selector')) return;
  class PackSelector extends HTMLElement {
    connectedCallback() {
      if (this.controller || !this.hasAttribute('data-card-switch')) return;
      this.controller = new AbortController();
      this.addEventListener('click', event => {
        const option = event.target.closest('[data-pack-link]');
        if (!option || event.button || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
        const card = this.closest('[data-world-card]');
        if (!card) return;
        event.preventDefault();
        card.querySelectorAll('.prw-card__link').forEach(link => { link.href = option.href; link.setAttribute('aria-label', option.dataset.title); });
        const image = card.querySelector('.prw-card__image');
        if (image && option.dataset.image) { image.removeAttribute('srcset'); image.src = option.dataset.image; image.alt = option.dataset.title; }
        card.querySelector('.prw-card__info h3').textContent = option.dataset.cardTitle || option.dataset.title;
        const price = card.querySelector('.prw-card__price');
        price.replaceChildren();
        const value = document.createElement('span'); value.textContent = option.dataset.money; price.append(value);
        if (option.dataset.compare) { const compare = document.createElement('s'); compare.textContent = option.dataset.compare; price.append(compare); }
        card.dataset.price = option.dataset.price; card.dataset.available = option.dataset.available;
        const sale = card.querySelector('[data-sale-badge]');
        if (sale) {
          const currentPrice = Number(option.dataset.price), comparePrice = Number(option.dataset.comparePrice);
          const percent = Number.isFinite(comparePrice) && comparePrice > currentPrice && currentPrice >= 0 ? Math.floor((comparePrice-currentPrice)*100/comparePrice) : 0;
          card.dataset.discount = String(percent);
          sale.hidden = percent <= 0;
          sale.dataset.deepSale = String(percent > 50);
          sale.textContent = percent > 0 ? `Sale −${percent} %` : '';
        }
        const badge = card.querySelector('[data-stock-badge]'); if (badge) badge.hidden = option.dataset.available === 'true';
        card.dispatchEvent(new CustomEvent('pr:pack-change', {bubbles:true}));
        this.querySelectorAll('[data-pack-link]').forEach(link => { if (link === option) link.setAttribute('aria-current','true'); else link.removeAttribute('aria-current'); });
      }, {signal:this.controller.signal});
    }
    disconnectedCallback() { this.controller?.abort(); this.controller = null; }
  }
  customElements.define('pr-pack-selector', PackSelector);
})();

(() => {
  if (window.prProductNavigation) return;
  window.prProductNavigation = true;
  let request, generation = 0, busy = false, historyRetry;
  const main = () => document.querySelector('pr-series-product[data-generic-product]');
  const selector = () => main()?.querySelector('pr-pack-selector, .pr-pack-switch--sets');
  const openDetails = () => {
    const target = document.getElementById('pr-product-details');
    if (!target) return;
    target.open = true;
    target.scrollIntoView({ behavior: 'instant', block: 'start' });
    target.querySelector('summary')?.focus({ preventScroll: true });
  };
  const navigate = async (href, push = true) => {
    const current = main();
    if (!current) return;
    if (current.inFlight || current.needsReview) {
      if (!push) {
        clearTimeout(historyRetry);
        historyRetry = setTimeout(() => navigate(location.href, false), 150);
      }
      return;
    }
    clearTimeout(historyRetry);
    request?.abort(); request = new AbortController();
    const turn = ++generation;
    const anchor = selector(), top = anchor?.getBoundingClientRect().top, y = window.scrollY;
    const url = new URL(href, location.href);
    const preview = new URL(location.href).searchParams.get('preview_theme_id');
    if (preview) url.searchParams.set('preview_theme_id', preview);
    url.hash = '';
    busy = true; current.setAttribute('aria-busy', 'true');
    try {
      const response = await fetch(url.href, { signal: request.signal, credentials: 'same-origin' });
      if (!response.ok) throw new Error('Product unavailable');
      const page = new DOMParser().parseFromString(await response.text(), 'text/html');
      if (turn !== generation) return;
      const incoming = page.querySelector('pr-series-product[data-generic-product]');
      if (!incoming?.querySelector('[name="id"]') || !page.querySelector('#pr-product-details')) throw new Error('Incomplete product');
      const replacements = ['pr-series-product[data-generic-product]', '[id$="__universe"]', '#pr-series-faq'].map(query => {
        const old = document.querySelector(query)?.closest('.shopify-section');
        const fresh = page.querySelector(query)?.closest('.shopify-section');
        if (!old || !fresh) throw new Error('Missing product section');
        return [old, document.importNode(fresh, true)];
      });
      const root = document.documentElement, prior = root.style.scrollBehavior;
      root.style.scrollBehavior = 'auto';
      replacements.forEach(([old, fresh]) => old.replaceWith(fresh));
      document.title = page.title;
      if (push) history.pushState({ prProduct: true }, '', url.pathname + url.search);
      const nextAnchor = selector();
      window.scrollTo({ top: top != null && nextAnchor ? window.scrollY + nextAnchor.getBoundingClientRect().top - top : y, behavior: 'instant' });
      nextAnchor?.querySelector('[aria-current="true"]')?.focus({ preventScroll: true });
      root.style.scrollBehavior = prior;
    } catch (error) {
      if (turn !== generation || error.name === 'AbortError') return;
      if (!push) { location.reload(); return; }
      current.notice(current.dataset.switchError);
    } finally {
      if (turn === generation) { busy = false; main()?.removeAttribute('aria-busy'); }
    }
  };
  document.addEventListener('submit', event => {
    if (busy && event.target.closest('pr-series-product[data-generic-product]')) { event.preventDefault(); event.stopImmediatePropagation(); }
  }, true);
  document.addEventListener('click', event => {
    if (event.button || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
    const details = event.target.closest('a[href="#pr-product-details"]');
    if (details) { event.preventDefault(); event.stopImmediatePropagation(); openDetails(); return; }
    const link = event.target.closest('pr-series-product[data-generic-product] pr-pack-selector a[data-pack-link], pr-series-product[data-generic-product] .pr-pack-switch--sets a');
    if (!link) return;
    event.preventDefault(); event.stopImmediatePropagation();
    if (link.getAttribute('aria-current') !== 'true' || busy) navigate(link.href);
  }, true);
  window.addEventListener('pagehide', () => { clearTimeout(historyRetry); request?.abort(); });
  window.addEventListener('popstate', () => { if (main()) navigate(location.href, false); });
  if (location.hash === '#pr-product-details') requestAnimationFrame(openDetails);
})();
